<template>
    <!-- 模型管理 -->
    <div class="max_box">
      <!-- top -->
      <div class="top_box"><span class="top_span">质检方案</span></div>
      <div class="form_box">
        <!-- form -->
        <span style="margin-top: 20px;">
          <el-input size="small" @keyup.enter.native="search" placeholder="请输入方案名称" v-model="planName" class="input-with-select" style="width:320px;">
            <el-button @click="search" size="small"  slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </span>
        <span style="margin-top: 20px;margin-left:15px;">
          <el-button @click="addQcPlan" style="width:140px" size="small" type="success" icon="el-icon-plus" >新增质检方案</el-button>
        </span>
      </div>
      <!-- table -->
      <el-table class="table_box_el_table" stripe :data="planTableData" v-loading="load_table">
          <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60px">
          </el-table-column>
          <el-table-column label="方案名称" align="center" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                  <span class="table_span">{{ scope.row.name }}</span>
              </template>
          </el-table-column>
          <el-table-column label="质检模型" align="center" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                  <span class="table_span">{{ scope.row.qcItemsName }}</span>
              </template>
          </el-table-column>
          <el-table-column label="描述" align="center" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                  <span class="table_span">{{ scope.row.describ}}</span>
              </template>
          </el-table-column>
          <el-table-column label="创建时间" align="center" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                  <span class="table_span">{{ datetimeFormat(Number(scope.row.createdTime)) }}</span>
              </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="150px">
              <template slot-scope="scope">
                  <div class="table_button_box">
                      <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                        <el-button icon="el-icon-edit"
                              class="table_button" circle size="mini" @click="editQcPlan(scope.row)" type="primary">
                        </el-button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="删除" placement="top">
                        <el-button :icon="remove_id==scope.row.id?'el-icon-loading':'el-icon-delete'"
                              class="table_button" circle size="mini" @click="reomveQcPlan(scope.row.id)" type="danger">
                        </el-button>
                      </el-tooltip>
                  </div>
              </template>
          </el-table-column>
      </el-table>
      <!-- page -->
      <Page v-bind:init_item="pageBuild" @currentPage="currentPage"/>

      <el-drawer
        :title="operationTitle"
        :before-close="handleClose"
        :visible.sync="dialog"
        style="font-size:14px;"
        custom-class="demo-drawer"
        ref="drawer"
        size="50%;">
        <div class="demo-drawer__content" style="margin-left:10px;">
          <el-form :model="formData" ref="ruleForm"  :rules="rules">
            <el-form-item label="方案名称" :label-width="formLabelWidth" prop="name">
              <el-input v-model="formData.name" autocomplete="off" placeholder="请输入任务名称" style="width:80%;"></el-input>
            </el-form-item>
            <el-form-item label="方案描述" :label-width="formLabelWidth" prop="describ">
                <el-input
                  type="textarea"
                  placeholder="请输入内容"
                  v-model="formData.describ"
                  maxlength="100"
                  show-word-limit
                  style="width:80%;">
                </el-input>
            </el-form-item>
            <el-form-item label="评分模板" :label-width="formLabelWidth">
              <p style="width:80%">
                基准分100分，分别计扣分项、加分项、致命项
                扣分和加分都可设上限，即扣分（或加分）到一定分数就不再计算其他扣分项（或加分项）
                致命项指一旦符合某种情况，整通会话记为零分
              </p>
            </el-form-item>

            <el-row>
                <el-col :span="8">
                    <el-form-item label="扣分上限" prop="deductLimit" :label-width="formLabelWidth">
                        <el-input-number v-model="formData.deductLimit" size="small"  style="width:110px;height:32px;" controls-position="right" :min="1" :max="100"></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="加分上限" prop="bonusLimit" :label-width="formLabelWidth">
                    <el-input-number v-model="formData.bonusLimit" size="small"  style="width:110px;height:32px" controls-position="right" :min="1" :max="100"></el-input-number>
                  </el-form-item>
                </el-col>
            </el-row>

            <template>
              <el-tabs v-model="classifyType" style="margin-top:15px;" type="card">
                <el-tab-pane label="扣分项" name="deduct" class="dialog_table zjmc">
                  <el-table :data="deductItems" stripe align="center" max-height="360" width="100%">
                    <el-table-column label="序号" type="index" width="60px"></el-table-column>
                    <el-table-column label="质检项名称"  :show-overflow-tooltip="true"  align="center" width="200">
                      <template slot-scope="scope">
                          <span class="table_span zjmcfh"  v-show="!scope.row.nameEditing" >
                            {{ scope.row.name }}
                          </span>
                          <i class="el-icon-edit zjmcfhicon" @click="editItems($event, scope, 'name')" v-show="!scope.row.nameEditing" style="cursor:pointer"></i>
                          <el-input v-model="scope.row.name" style="width:150px" autocomplete="off" v-show="scope.row.nameEditing"  @blur="saveItems(scope.row, 'name')"
                            @keyup.enter.native="saveItems(scope.row, 'name')" size="small" placeholder="请输入质检项名称" ></el-input>
                          <i class="el-icon-check" @click="saveItems(scope.row, 'name')" v-show="scope.row.nameEditing" style="padding-left:5px;cursor:pointer"></i>
                      </template>
                    </el-table-column>
                    <i class="el-icon-edit"  style="cursor:pointer"></i>

                    <el-table-column label="质检项说明" align="center" :show-overflow-tooltip="true" width="200">
                      <template slot-scope="scope">
                          <span class="table_span zjmcfh"  v-show="!scope.row.remarkEditing" >{{ scope.row.remark }}</span>
                          <i class="el-icon-edit zjmcfhicon" @click="editItems($event, scope, 'remark')" v-show="!scope.row.remarkEditing" style="padding-left:5px;cursor:pointer"></i>
                          <el-input v-model="scope.row.remark"  autocomplete="off" v-show="scope.row.remarkEditing"  @blur="saveItems(scope.row, 'remark')"
                            @keyup.enter.native="saveItems(scope.row, 'remark')" size="small" style="width:150px" placeholder="请输入质检项说明" ></el-input>
                          <i class="el-icon-check" @click="saveItems(scope.row, 'remark')" v-show="scope.row.remarkEditing" style="padding-left:5px;cursor:pointer"></i>
                      </template>
                    </el-table-column>

                    <el-table-column label="质检模型" align="center" width="150">
                      <template slot-scope="scope">
                        <el-cascader  v-model="scope.row.modelIdList" :show-all-levels="false" size="mini"
                              :options="modelGroupList" :props="props"
                              @change="modelHandleChange">
                        </el-cascader>
                      </template>
                    </el-table-column>

                    <el-table-column label="分值" align="center" width="120">
                      <template slot-scope="scope">
                          <el-input-number v-model="scope.row.score"  style="width:100px" size="mini" controls-position="right" :min="1" :max="100"></el-input-number>
                      </template>
                    </el-table-column>

                    <el-table-column  label="类型" align="center" width="120">
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.type" size="mini" width="110">
                            <el-option
                              v-for="item in qcTypeOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                        </el-select>
                      </template>
                    </el-table-column>

                    <el-table-column label="操作" align="center" fixed="right">
                      <template slot-scope="scope">
                          <div class="table_button_box">
                              <el-button :icon="model_remove_id==scope.row.id?'el-icon-loading':'el-icon-delete'"
                                      class="table_button" circle size="mini" @click="reomveItems(scope)" type="danger">
                              </el-button>
                          </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane label="加分项" name='awarded' class="dialog_table zjmc">
                  <el-table :data="awardedItems" stripe align="center" max-height="360" width="100%">
                    <el-table-column label="序号" type="index" width="60px"></el-table-column>
                    <el-table-column label="质检项名称" align="center" :show-overflow-tooltip="true" width="200">
                      <template slot-scope="scope">
                          <span class="table_span zjmcfh"  v-show="!scope.row.nameEditing" >{{ scope.row.name }}</span>
                          <i class="el-icon-edit zjmcfhicon" @click="editItems($event, scope, 'name')" v-show="!scope.row.nameEditing" style="cursor:pointer"></i>
                          <el-input v-model="scope.row.name"  style="width:150px"  autocomplete="off" v-show="scope.row.nameEditing"  @blur="saveItems(scope.row, 'name')"
                            @keyup.enter.native="saveItems(scope.row, 'name')" size="small" placeholder="请输入质检项名称" ></el-input>
                          <i class="el-icon-check" @click="saveItems(scope.row, 'name')" v-show="scope.row.nameEditing" style="padding-left:5px;cursor:pointer"></i>
                      </template>
                    </el-table-column>

                    <el-table-column label="质检项说明" align="center" :show-overflow-tooltip="true" width="200">
                      <template slot-scope="scope">
                          <span class="table_span zjmcfh"  v-show="!scope.row.remarkEditing" >{{ scope.row.remark }}</span>
                          <i class="el-icon-edit zjmcfhicon" @click="editItems($event, scope, 'remark')" v-show="!scope.row.remarkEditing" style="padding-left:5px;cursor:pointer"></i>
                          <el-input v-model="scope.row.remark"  autocomplete="off" v-show="scope.row.remarkEditing"  @blur="saveItems(scope.row, 'remark')"
                            @keyup.enter.native="saveItems(scope.row, 'remark')" size="small" style="width:150px" placeholder="请输入质检项说明" ></el-input>
                          <i class="el-icon-check" @click="saveItems(scope.row, 'remark')" v-show="scope.row.remarkEditing" style="padding-left:5px;cursor:pointer"></i>
                      </template>
                    </el-table-column>

                    <el-table-column label="质检模型" align="center" width="150">
                      <template slot-scope="scope">
                        <el-cascader  v-model="scope.row.modelIdList" :show-all-levels="false" size="mini"
                              :options="modelGroupList" :props="props"
                              @change="modelHandleChange">
                        </el-cascader>
                      </template>
                    </el-table-column>

                    <el-table-column label="分值" align="center" width="120">
                      <template slot-scope="scope">
                          <el-input-number v-model="scope.row.score"  style="width:100px" size="mini" controls-position="right" :min="1" :max="100"></el-input-number>
                      </template>
                    </el-table-column>

                    <el-table-column  label="类型" align="center" width="120">
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.type" size="mini" width="110">
                            <el-option
                              v-for="item in qcTypeOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                        </el-select>
                      </template>
                    </el-table-column>

                    <el-table-column label="操作" align="center" fixed="right">
                      <template slot-scope="scope">
                          <div class="table_button_box">
                              <el-button :icon="model_remove_id==scope.row.id?'el-icon-loading':'el-icon-delete'"
                                      class="table_button" circle size="mini" @click="reomveItems(scope)" type="danger">
                              </el-button>
                          </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane label="致命项" name='deadly' class="dialog_table zjmc">
                  <el-table :data="deadlyItems" stripe align="center" max-height="360" width="100%">
                    <el-table-column label="序号" type="index" width="60px"></el-table-column>
                    <el-table-column label="质检项名称" align="center" :show-overflow-tooltip="true" width="200">
                      <template slot-scope="scope">
                          <span class="table_span zjmcfh"  v-show="!scope.row.nameEditing" >{{ scope.row.name }}</span>
                          <i class="el-icon-edit zjmcfhicon" @click="editItems($event, scope, 'name')" v-show="!scope.row.nameEditing" style="cursor:pointer"></i>
                          <el-input v-model="scope.row.name"  style="width:150px"  autocomplete="off" v-show="scope.row.nameEditing"  @blur="saveItems(scope.row, 'name')"
                            @keyup.enter.native="saveItems(scope.row, 'name')" size="small" placeholder="请输入质检项名称" ></el-input>
                          <i class="el-icon-check" @click="saveItems(scope.row, 'name')" v-show="scope.row.nameEditing" style="padding-left:5px;cursor:pointer"></i>
                      </template>
                    </el-table-column>

                    <el-table-column label="质检项说明" align="center" :show-overflow-tooltip="true" width="200">
                      <template slot-scope="scope">
                          <span class="table_span zjmcfh"  v-show="!scope.row.remarkEditing" >{{ scope.row.remark }}</span>
                          <i class="el-icon-edit zjmcfhicon" @click="editItems($event, scope, 'remark')" v-show="!scope.row.remarkEditing" style="padding-left:5px;cursor:pointer"></i>
                          <el-input v-model="scope.row.remark"  autocomplete="off" v-show="scope.row.remarkEditing"  @blur="saveItems(scope.row, 'remark')"
                            @keyup.enter.native="saveItems(scope.row, 'remark')" size="small" style="width:150px" placeholder="请输入质检项说明" ></el-input>
                          <i class="el-icon-check" @click="saveItems(scope.row, 'remark')" v-show="scope.row.remarkEditing" style="padding-left:5px;cursor:pointer"></i>
                      </template>
                    </el-table-column>

                    <el-table-column label="质检模型" align="center" width="150">
                      <template slot-scope="scope">
                        <el-cascader  v-model="scope.row.modelIdList" :show-all-levels="false" size="mini"
                              :options="modelGroupList" :props="props"
                              @change="modelHandleChange">
                        </el-cascader>
                      </template>
                    </el-table-column>

                    <el-table-column  label="类型" align="center" width="120">
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.type" size="mini" width="110">
                            <el-option
                              v-for="item in qcTypeOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                        </el-select>
                      </template>
                    </el-table-column>

                    <el-table-column label="操作" align="center" fixed="right">
                      <template slot-scope="scope">
                          <div class="table_button_box">
                              <el-button :icon="model_remove_id==scope.row.id?'el-icon-loading':'el-icon-delete'"
                                      class="table_button" circle size="mini" @click="reomveItems(scope)" type="danger">
                              </el-button>
                          </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
            </template>
            <el-button type="primary" size="small" icon="el-icon-plus" style="margin-top:10px;height:32px;" @click="addItems">增加一行</el-button>
          </el-form>
          <div class="demo-drawer__footer" style="text-align:center;margin-bottom: 20px;padding-bottom:0px;">
            <el-button @click="cancelForm()">取 消</el-button>
            <el-button type="primary" @click="submitForm" :loading="loading">{{ loading ? '提交中 ...' : '保 存' }}</el-button>
          </div>
        </div>
      </el-drawer>

    </div>
</template>

<script>
import Page from '@/views/qc/public/PageComponent'
import { getQcPlanList, deleteQcPlan, updateQcPlan, saveQcPlan, getQcPlanByName } from '@/api/qc/plan.js'
import { modelGroupList, modelByGroupId } from '@/api/qc/model.js'
export default {
  name: 'modelManagement',
  components: {
    Page
  },
  data: function () {
    const isInteger = (rule, value, callback) => {
      if (!Number.isInteger(Number(value))) {
        callback(new Error('只能输入数字'))
      } else {
        callback()
      }
    }
    const checkNameExclude = (rule, value, callback) => {
      var params = {
        name: this.formData.name,
        excludeId: this.formData.id
      }
      getQcPlanByName(params).then(res => {
        if (res.data.code === 2000) {
          if (res.data.data != null && res.data.data !== '') {
            callback(new Error('方案名已存在'))
          } else {
            callback()
          }
        } else {
          window.qcMessage({ type: 'error', text: '系统异常' })
        }
      }).catch(res => {
        window.qcMessage({ type: 'error', text: '系统异常' })
      })
    }

    return {
      visible: false,
      planName: '',
      dialog: false,
      loading: false,
      timer: null,
      planTableData: [],
      remove_id: '',
      model_remove_id: '',
      load_table: false,
      classifyType: 'deduct',
      operationTitle: '新增质检方案',
      pageBuild: {
        page_size: 10,
        total: 0,
        currentPage: 1,
        name: ''
      },
      formData: {
        id: '',
        name: '',
        describ: '',
        deductLimit: 0,
        bonusLimit: 0
      },
      formLabelWidth: '80px',
      modelGroupList: [],
      props: {
        lazy: true,
        lazyLoad (node, resolve) {
          const params = {
            group_id: node.value
          }
          modelByGroupId(params).then(res => {
            if (res.data.code === 2000) {
              var nodes = []
              for (var i = 0; i < res.data.data.list.length; i++) {
                var model = {}
                model.value = res.data.data.list[i].id
                model.label = res.data.data.list[i].name
                model.leaf = true
                nodes.push(model)
              }
              resolve(nodes)
            } else {
              window.qcMessage({ type: 'error', text: '获取数据失败！' })
            }
          }).catch(res => {
            window.qcMessage({ type: 'error', text: '获取数据失败！' })
          })
        }
      },
      deductItems: [],
      awardedItems: [],
      deadlyItems: [],
      qcTypeOptions: [{
        value: 1,
        label: '正向'
      }, {
        value: 2,
        label: '负向'
      }],

      rules: {
        name: [
          { required: true, message: '请输入方案名称', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' },
          { validator: checkNameExclude, trigger: 'blur' }
        ],
        describ: [
          { required: true, message: '请输入方案描述', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ],
        deductLimit: [
          { required: true, message: '请输入扣分上限', trigger: 'blur' },
          { validator: isInteger, trigger: 'blur' }
        ],
        bonusLimit: [
          { required: true, message: '请输入加分上限', trigger: 'blur' },
          { validator: isInteger, trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    // 删除质检方案
    reomveQcPlan(id) {
      const that = this
      window.qcMessageBox({
        title: '',
        text: '确认要删除该质检方案吗？',
        f: function() {
          that.loading = true
          if (id !== '' && id != null) {
            deleteQcPlan(id).then(res => {
              if (res.data.code === 2000) {
                window.qcMessage({ type: 'success', text: '删除成功' })
              } else {
                window.qcMessage({ type: 'error', text: '系统异常' })
              }
              that.loading = false
              that.search()
            }).catch(res => {
              window.qcMessage({ type: 'error', text: '系统异常' })
            })
          }
        },
        c: function() { that.dialog = false }
      })
    },

    // 删除质检项
    reomveItems(scope) {
      if (scope.row.classify === 1) {
        this.deductItems.splice(scope.$index, 1)
      } else if (scope.row.classify === 2) {
        this.awardedItems.splice(scope.$index, 1)
      } else {
        this.deadlyItems.splice(scope.$index, 1)
      }
    },

    // 选择质检model后触发事件
    modelHandleChange(value, row, column) {
      // console.log(this.deductItems)
    },

    // 双击修改文本结束
    saveItems(row, type) {
      if (type === 'name') {
        row.nameEditing = false
      } else {
        row.remarkEditing = false
      }
    },

    // 新增质检行
    addItems() {
      var itemsData = {}
      itemsData.name = '质检项名称'
      itemsData.remark = '质检项说明'
      itemsData.modelId = ''
      itemsData.type = 1
      itemsData.nameEditing = false
      itemsData.remarkEditing = false
      if (this.classifyType === 'deduct') {
        itemsData.classify = 1
        itemsData.score = 10
        this.deductItems.push(itemsData)
      } else if (this.classifyType === 'awarded') {
        itemsData.classify = 2
        itemsData.score = 10
        this.awardedItems.push(itemsData)
      } else {
        itemsData.classify = 3
        itemsData.score = 0
        this.deadlyItems.push(itemsData)
      }
    },

    submitForm(done) {
      const that = this
      if (that.loading) {
        return
      }
      that.$refs.ruleForm.validate((valid) => {
        if (valid) {
          var qcItemsList = []
          for (var i = 0; i < that.deductItems.length; i++) {
            if (that.deductItems[i].name == null || that.deductItems[i].name === '') {
              window.qcMessage({ type: 'warning', text: '质检项名称不能为空' })
              this.classifyType = 'deduct'
              return false
            }

            if (that.deductItems[i].remark == null || that.deductItems[i].remark === '') {
              window.qcMessage({ type: 'warning', text: '质检说明不能为空' })
              this.classifyType = 'deduct'
              return false
            }

            if (that.deductItems[i].modelIdList == null || that.deductItems[i].modelIdList === '') {
              window.qcMessage({ type: 'warning', text: '质检模型不能为空' })
              this.classifyType = 'deduct'
              return false
            }

            qcItemsList.push(that.deductItems[i])
          }

          for (var j = 0; j < that.awardedItems.length; j++) {
            if (that.awardedItems[i].name == null || that.awardedItems[i].name === '') {
              window.qcMessage({ type: 'warning', text: '质检项名称不能为空' })
              this.classifyType = 'awarded'
              return false
            }

            if (that.awardedItems[i].remark == null || that.awardedItems[i].remark === '') {
              window.qcMessage({ type: 'warning', text: '质检说明不能为空' })
              this.classifyType = 'awarded'
              return false
            }

            if (that.awardedItems[j].modelIdList == null || that.awardedItems[j].modelIdList === '') {
              window.qcMessage({ type: 'warning', text: '质检模型不能为空' })
              this.classifyType = 'awarded'
              return false
            } else {
              qcItemsList.push(that.awardedItems[j])
            }
          }

          for (var k = 0; k < that.deadlyItems.length; k++) {
            if (that.deadlyItems[i].name == null || that.deadlyItems[i].name === '') {
              window.qcMessage({ type: 'warning', text: '质检项名称不能为空' })
              this.classifyType = 'deadly'
              return false
            }

            if (that.deadlyItems[i].remark == null || that.deadlyItems[i].remark === '') {
              window.qcMessage({ type: 'warning', text: '质检说明不能为空' })
              this.classifyType = 'deadly'
              return false
            }

            if (that.deadlyItems[k].modelIdList == null || that.deadlyItems[k].modelIdList === '') {
              window.qcMessage({ type: 'warning', text: '质检模型不能为空' })
              this.classifyType = 'deadly'
              return false
            } else {
              qcItemsList.push(that.deadlyItems[k])
            }
          }

          if (qcItemsList.length === 0) {
            window.qcMessage({ type: 'warning', text: '质检项不能为空' })
            return false
          }

          that.formData.qcItemsList = qcItemsList

          window.qcMessageBox({
            title: '',
            text: '确认要提交表单吗？',
            f: function() {
              that.loading = true
              if (that.formData.id === '' || that.formData.id == null) {
                // 新增质检方案
                saveQcPlan(that.formData).then(res => {
                  if (res.data.code === 2000) {
                    window.qcMessage({ type: 'success', text: '提交成功' })
                  } else {
                    window.qcMessage({ type: 'error', text: '系统异常' })
                  }
                  that.loading = false
                  that.search()
                  that.cancelForm()
                }).catch(res => {
                  window.qcMessage({ type: 'error', text: '系统异常' })
                })
              } else {
                // 更新质检方案
                updateQcPlan(that.formData).then(res => {
                  if (res.data.code === 2000) {
                    window.qcMessage({ type: 'success', text: '提交成功' })
                  } else {
                    window.qcMessage({ type: 'error', text: '系统异常' })
                  }
                  that.loading = false
                  that.search()
                  that.cancelForm()
                }).catch(res => {
                  window.qcMessage({ type: 'error', text: '系统异常' })
                })
              }
            },
            c: function() { that.dialog = false; that.cancelForm() }
          })
        } else {
          return false
        }
      })
    },

    // 双击开始修改质检行
    editItems: function (e, scope, type) {
      if (type === 'name') {
        scope.row.nameEditing = true
      } else {
        scope.row.remarkEditing = true
      }
      this.$nextTick(function () {
        e.currentTarget.nextElementSibling.children[0].focus()
      })
    },

    handleClose(done) {
      this.cancelForm()
    },

    cancelForm() {
      this.loading = false
      this.dialog = false
      this.classifyType = 'deduct'
      this.formData.id = ''
      this.formData.name = ''
      this.formData.describ = ''
      this.formData.deductLimit = 0
      this.formData.bonusLimit = 0
      this.deductItems = []
      this.awardedItems = []
      this.deadlyItems = []
      clearTimeout(this.timer)
      this.resetForm()
    },

    resetForm() { // 还原form表单验证
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    addQcPlan() {
      this.cancelForm()
      this.operationTitle = '新增质检方案'
      this.dialog = true
    },

    async editQcPlan(row) {
      this.operationTitle = '修改质检方案'
      this.formData.id = row.id
      this.formData.name = row.name
      this.formData.describ = row.describ
      this.classifyType = 'deduct'
      this.formData.deductLimit = row.deductLimit
      this.formData.bonusLimit = row.bonusLimit
      this.formData.group = row.group
      this.deductItems = []
      this.awardedItems = []
      this.deadlyItems = []
      for (var i = 0; i < row.qcItemsList.length; i++) {
        var qcItem = row.qcItemsList[i]
        var groupId = qcItem.modelIdList[0]

        let flag = true
        for (var j = 0; j < this.modelGroupList.length; j++) {
          if (this.modelGroupList[j].value === groupId && this.modelGroupList[j].children != null) {
            flag = false
            break
          }
        }

        if (flag) {
          const params = {
            group_id: groupId
          }
          await modelByGroupId(params).then(res => {
            if (res.data.code === 2000) {
              var nodes = []
              for (var i = 0; i < res.data.data.list.length; i++) {
                var model = {}
                model.value = res.data.data.list[i].id
                model.label = res.data.data.list[i].name
                model.leaf = true
                nodes.push(model)
              }

              for (var j = 0; j < this.modelGroupList.length; j++) {
                if (this.modelGroupList[j].value === groupId) {
                  this.modelGroupList[j].children = nodes
                  break
                }
              }
            } else {
              window.qcMessage({ type: 'error', text: '获取数据失败！' })
            }
          }).catch(res => {
            window.qcMessage({ type: 'error', text: '获取数据失败！' })
          })
        }

        if (qcItem.classify === 1) {
          this.deductItems.push(qcItem)
        } else if (qcItem.classify === 2) {
          this.awardedItems.push(qcItem)
        } else {
          this.deadlyItems.push(qcItem)
        }
      }
      this.dialog = true
    },

    indexMethod(index) {
      return index + 1 + this.pageBuild.page_size * (this.pageBuild.currentPage - 1)
    },

    currentPage(currentPage) {
      this.search(currentPage)
    },

    search(currentPage) {
      const that = this
      // this.pageBuild.currentPage = 1
      // eslint-disable-next-line no-unneeded-ternary
      // eslint-disable-next-line eqeqeq
      that.pageBuild.currentPage = typeof currentPage == 'number' ? currentPage : 1
      that.pageBuild.name = this.planName
      that.planTableData = []
      that.load_table = true
      getQcPlanList(this.pageBuild).then(res => {
        if (res.data.code === 2000) {
          that.planTableData = res.data.data.root
          that.pageBuild.total = res.data.data.totalProperty
        } else {
          window.qcMessage({ type: 'error', text: '获取数据失败！' })
        }
        that.load_table = false
      }).catch(res => {
        window.qcMessage({ type: 'error', text: '获取数据异常！' })
        that.load_table = false
      })
    },

    // 获得所有的质检模型组
    getModelGroup() {
      modelGroupList().then(res => {
        if (res.data.code === 2000) {
          for (var i = 0; i < res.data.data.list.length; i++) {
            var model = {}
            model.value = res.data.data.list[i].id
            model.label = res.data.data.list[i].name
            this.modelGroupList.push(model)
          }
        } else {
          window.qcMessage({ type: 'error', text: '获取数据失败！' })
        }
      }).catch(res => {
        window.qcMessage({ type: 'error', text: '获取数据失败！' })
      })
    },

    datetimeFormat(longTypeDate) {
      var datetimeType = ''
      var date = new Date()
      date.setTime(longTypeDate)
      datetimeType += date.getFullYear()
      datetimeType += '-' + (date.getMonth() + 1)
      datetimeType += '-' + date.getDate()
      datetimeType += ' ' + date.getHours()
      datetimeType += ':' + date.getMinutes()
      datetimeType += ':' + date.getSeconds()
      return datetimeType
    }
  },
  mounted() {
    this.search()
    this.getModelGroup()
  }
}
</script>

<style  scoped>
    .drawer_input{
        width: 450px;
    }
    .max_box{
        width: 100%;
    }
    .top_box{
        width: 100%;
        border-bottom: #e1e3e6 solid 1px;
        padding-top: 12px;
        padding-bottom: 9px;
        margin-bottom: 20px;
    }
    .top_span{
        color: #222;
        font-size: 20px;
        padding-bottom: 10px;
        border-bottom: #0080fe solid 1px;
        padding-right: 5px;
    }
    .form_box{
        width: 100%;
    }
    .form_label{
        font-size: 14px;
    }
    .form_input{
        width: 200px;
        margin-right: 20px;
    }
    .table_span{
        margin-left: 5px;
    }
    .table_box_el_table >>> .el-table__body-wrapper >.el-table__body tbody tr .el-table_1_column_1 .cell div{
        width: 22px !important;
        border-radius: 15px;
        background: #eee;
        margin-left: 2px;
    }
    /deep/.el-drawer{
        overflow: auto;
    }
    /deep/.dialog_table{
      overflow: auto;
      /* max-height: 360px; */
    }
    .el-drawer__wrapper >>> .el-drawer__header > span:focus{
        outline:0px solid;
    }
    .el-col {
      border-radius: 4px;
    }
    .grid-content {
      border-radius: 4px;
      min-height: 36px;
    }
    .row-bg {
      padding: 10px 0;
      background-color: #f9fafc;
    }
    .demo-drawer__footer{
      text-align:center;margin-top:50px;
    }
    .table_box_el_table{
          width: 100%;
          margin-top: 15px;
    }
    .el-table >>> thead tr th{
        background: #f1f1f1 !important;
        padding: 6px 0 !important;
        color: #777 !important;
    }
    /deep/ body {
      color:black;
    }
    /* /deep/.el-tabs--card .el-tabs__header .el-tabs__item {
        background-color: white;
        border: 1px solid #edeef0;
        color: black;
    } */
    /deep/.el-tabs--card .el-tabs__header .el-tabs__item.is-active {
      background-color: #fff;
      border-bottom-color: white;
      color: #337eff;
    }
    /deep/.el-tabs--card .el-tabs__header .el-tabs__item {
      background-color: white;
      border: 1px solid #edeef0;
      color: black;
    }
    .el-drawer__wrapper >>> .el-drawer__header > span{
        font-size: 16px;
        border-left: #337eff solid 3px;
        line-height: 14px;
        padding-left: 10px;
    }
    .el-drawer__wrapper >>> .el-drawer__header{
        border-bottom: #e1e3e6 solid 1px;
        padding: 0px 0 10px 0;
        margin-bottom: 15px;
    }
    .el-drawer__wrapper >>> .el-drawer{
        padding: 20px;
    }

    .zjmcfh{
      width:130px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      display:inline-block;
      height: 28px;
      line-height: 28px;
    }
    .zjmc >>>  .cell.el-tooltip{position: relative;}
    .zjmcfhicon{
      position:absolute;
      right: 15px;
      top:10px;
    }
    .el-form .el-form-item >>> .el-input__inner{
      height: 32px;
    }
    .el-form .el-form-item >>> .el-textarea__inner{
      height: 68px;
    }
</style>
